import { render, staticRenderFns } from "./Ages.vue?vue&type=template&id=6d2760a0"
import script from "./Ages.vue?vue&type=script&lang=js"
export * from "./Ages.vue?vue&type=script&lang=js"
import style0 from "./Ages.vue?vue&type=style&index=0&id=6d2760a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports